import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';

export default class FMPBulkFormulaSelect extends PureComponent {
	render () {
		const {
			label, value, path, onChange, bulkFormulas,
			error, helpText, md, readOnly, disabled,
		} = this.props;

		const hasError = !!error;
		const _onChange = event => {
			onChange(event.target.value, path);
		};

		return (<Grid spacing={2} container>
			<Grid item xs={12} md={md}>
				<FormControl fullWidth={true} error={hasError} disabled={disabled} >
					<InputLabel htmlFor={path}>{label}</InputLabel>
					<Select
						value={value}
						onChange={_onChange}
						input={<Input id={path} readOnly={readOnly} />}
					>
						{_.sortBy(bulkFormulas, 'display').map((bulkFormula, i) => {
							return (
								<MenuItem key={i} value={bulkFormula.bulkFormulaId}>
									{bulkFormula.display}
								</MenuItem>
							);
						})}
					</Select>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{(helpText && !hasError) && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		</Grid>);
	}
}

FMPBulkFormulaSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	bulkFormulas : PropTypes.array.isRequired,
	md : PropTypes.number,
	helpText : PropTypes.string,
	readOnly : PropTypes.bool,
	disabled : PropTypes.bool,
};


FMPBulkFormulaSelect.defaultProps =  {
	label : 'Bulk Formula',
	readOnly : false,
	md : 12
};